import { render, staticRenderFns } from "./PurchaseReturnsList.vue?vue&type=template&id=4173c96e&scoped=true&"
import script from "./PurchaseReturnsList.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturnsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4173c96e",
  null
  
)

export default component.exports